export default __webpack_public_path__ + "static/media/ItemListManagementOrangeIcon.9c6c0ea4.png";